// src/pages/a6/portfolios/table.tsx

import { Table } from "../../../features/Table";
import { type A6Portfolio, porfolios_columns } from "./columns";
import { type FilterA6PortfoliosSchema, FilterA6Portfolios } from "./filter";

const client = "a6";
const table_name = "a6_portfolios";

export const A6PortfoliosTable = () => {
  return (
    <Table<A6Portfolio, FilterA6PortfoliosSchema>
      label="Portfolios"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      columnVisibilityInit={{}}
      filter={<FilterA6Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
